<template>
  <div>
    <div class="card">
      <h5 class="card-header bg-custom text-white">Details</h5>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12"> 
              <div class="table-responsive">
                <table style="width: 100%" class="table table-sm table-borderless">
                  <tr>
                    <td style="width: 20%; border-right: 2px solid #f0f6ff !important">Subject</td>
                    <td>{{assignment.CourseName}}</td>
                  </tr>
                  <tr>
                    <td style="  border-right: 2px solid #f0f6ff !important">Title</td>
                    <td>{{assignment.Name}}</td>
                  </tr>
                  <tr>
                    <td style="  border-right: 2px solid #f0f6ff !important">Date</td>
                    <td>{{assignment.StartDate}}</td>
                  </tr>
                  <tr>
                    <td style="  border-right: 2px solid #f0f6ff !important">Deadline</td>
                    <td>{{assignment.EndDate}}</td>
                  </tr>
                  <tr>
                    <td style=" border-right: 2px solid #f0f6ff !important">Instuctions</td>
                    <td>{{assignment.Instruction}}</td>
                  </tr>
                  <tr>
                    <td style="   border-right: 2px solid #f0f6ff !important">Downloads</td>
                    <td>
                      <button v-for="item in assignment.Files" v-on:click="download(item.AssignmentFileID, item.FileName)" class="text-primary hover" style="text-decoration: underline; border: none; background-color: transparent"> {{item.FileName}} </button>
                    </td>
                  </tr>
                  <tr>
                    <td style="   border-right: 2px solid #f0f6ff !important">Upload File</td>
                    <td>
                      <input type="file" id="attachment" accept="image/*,.zip,.pdf,.rar" v-on:change="onfileupload">
                    </td>
                  </tr>
                </table>
              </div> 
          </div>
        </div>
      </div>

      <div class="card-footer bg-light ">
        <div class="form-row">
          <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12 text-right  ">
            <button class="btn btn-success " v-if="assignment.Open" type="button" v-on:click="save()" id="btnSubmit">Save</button>
            <button class="btn btn-danger btn-outline " type="button" v-on:click='cancel()' id="btnCancel">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default { 
    data() {
      return {
        assignment: {
          Name: '', Instruction: '', End: '', CourseName: ''
        },
        files: '', 
        fileid: '',
        caption: '',
        assignmentID: 0,
        attachment: '',
        allowedFormats: ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf', 
          'application/zip',
          'application/x-rar',
          'application/x-zip-compressed',
          'application/x-compressed',]
      }
    },
    created() {
      this.loadData();
    },

    methods: {
      loadData: function () {

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
          this.assignmentID = Number(urlParams.get('id'));
          var vm = this;
          startReq();
          axios.post('/api/PortalApi/loadAssignment?id=' + this.assignmentID)
            .then(function (res) {
              endReq();
              if (res.data.status)
                vm.assignment = res.data.file;
              else {
                alert(res.data.msg);
                window.location.href = "../Home";
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },

      save: function () {
        var vm = this;
        startReq();
        axios.post('/api/PortalApi/saveAssignment', {
          base64: vm.attachment,
          id: vm.assignmentID
        })
          .then(function (response) { 
            if (response.data['status']) { 
              window.location.href = "../Portal/Assingment";
              return;
            }
            else {
              endReq();
              toaster.error("Error",);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      reset: function () {
        location.reload();
      },
       
      //download(id) {
      //  var vm = this;
      //  axios.post('/api/PortalApi/StudentAssingmentSession?id=' + id)
      //    .then(function (response) {
      //      endReq();
      //      $('#downloadform').submit();
      //    })
      //    .catch(function (error) {
      //      endReq();
      //      console.log(error);
      //    });
      //},

      download(id, filename) {
        startReq()
        toastr.info("It may take some time, do not reload page");
        axios({
          url: '/api/PortalApi/downloadAssignmentStudent?id=' + id,
          method: 'GET',
          responseType: 'blob'
        })
          .then((response) => {
            if (response.status === 200) {
              const url =
                window.URL.createObjectURL
                  (new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
              endReq();
            } else {
              endReq();
              console.error('Error: Received non-200 status code');
            }
          })
          .catch((error) => {
            endReq();
            console.error('Error downloading the image:', error);
          });
      },

      cancel() {
        window.location.href = "../Portal/Assingment";
      },

      checkFile(file) { 
        if (file == null) {
          return false;
        } 
        if (file.size > 30000000) {
          toastr.error("file size is large maximum 30 mb is allowed", "Error!");

          return false;
        } 
        if (!this.allowedFormats.includes(file.type)) {
          toastr.error("Invalid file format, only pdf, image, rar and zip file is allowed");
          return false;
        }

        return true;
      },

      onfileupload: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var reader = new FileReader;
          reader.onload = (e) => {
            this.attachment = e.target.result
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
        else {
          $('#attachment').val('');
        }
      },
    }
  }</script>



// WEBPACK FOOTER //
// src/components/school/LMS/uploadAssingment.vue